	import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'MessageContentPopUpComponent',
	templateUrl: 'MessageContentPopUpComponent.html',
    
})
export class MessageContentPopUpComponent {
  
	constructor(
		private activeModal: NgbActiveModal,
		) {
		
	}

	@Input() public Title: string = "Content";

	@Input() public Content: string = "";

	@Input() public AdminContent: string = "";

	
	cancel() {
		this.activeModal.close();
	}
}
